import { SpaceVertical } from '@looker/components';
import type { FC } from 'react';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import { useSubGroupFilterState } from '../../../hooks/useSubGroupFilterState';
import ClinicalsRecency from '../ClinicalRecency';
import { ClinicalDeciles } from '../Deciles';
import { IncludeExcludeFilter } from '../IncludeExcludeFilter';
import PrescribingBehaviorChange from './ChangeFilter';
import PrescribingBehaviorType from './TypeFilter';

const PrescribingBehaviorFilter: FC<ICustomFilter> = ({ onChange, onExpressionTypeChange }) => {
  const { handleChange } = useSubGroupFilterState('prescribing_behavior_drug_name_filter', onChange);

  return (
    <SpaceVertical gap="u5" height={'100%'}>
      <PrescribingBehaviorChange onChange={handleChange} />
      <PrescribingBehaviorType onMultiFilterChange={handleChange} />
      <ClinicalsRecency
        onMultiFilterChange={handleChange}
        filterName="claims_lookback_period_filter"
        label="Clinical"
      />
      <ClinicalDeciles filterName={'prescribing_behavior_decile_filter'} onMultiFilterChange={handleChange} />
      <SpaceVertical height="100%">
        <IncludeExcludeFilter
          label={'Drugs'}
          filterName={'prescribing_behavior_drug_name_filter'}
          onMultiFilterChange={handleChange}
          onExpressionTypeChange={onExpressionTypeChange}
        />
      </SpaceVertical>
    </SpaceVertical>
  );
};

export default PrescribingBehaviorFilter;
